import {TextField} from '@mui/material';
import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {CheckBox} from '../../components/Inputs';
import {useBridge} from '../../hooks/use-bridge';
import '../../styles/plaid.css';

export default function BridgePage({user}) {
  const navigate = useNavigate();
  const {item_id} = useParams();
  const {
    state: {connections},
    removeConnection,
    editConnection,
  } = useBridge();

  const connection = connections[item_id] || {};
  const {account_mappings, id, entity_mappings} = connection;

  return (
    <div className="page-container">
      <div className="flex-row justify-between">
        <table>
          <thead>
            <tr>
              <th>Entity</th>
              <th>Bank</th>
              <th>Type</th>
              <th>Mask</th>
              <th>Status</th>
              <th>Ignore</th>
            </tr>
          </thead>
          <tbody>
            {account_mappings?.length > 0 &&
              account_mappings.map(item => {
                return (
                  <Row
                    key={item.account_id}
                    item={item}
                    user={user}
                    connection={connection}
                  />
                );
              })}
          </tbody>
        </table>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            marginRight: '32px',
          }}>
          <button
            className="disconnect"
            onClick={() => {
              navigate('/dashboard');
            }}>
            Done
          </button>
          <button
            className="disconnect"
            onClick={() => {
              try {
                removeConnection(connection);
                navigate('/dashboard');
              } catch (err) {
                console.log(err);
              }
            }}>
            Disconnect
          </button>
        </div>
      </div>
    </div>
  );
}

const Row = ({item, user, connection}) => {
  const {editConnection} = useBridge();

  const {
    id,
    display_name,
    display_number,
    acct_type,
    custodian,
    advisor_code,
    entity,
  } = item;

  const truncatedName =
    display_name.length > 20
      ? `${display_name.substring(0, 20)}...`
      : display_name;

  const [edit, setEdit] = useState(entity);

  return (
    <tr key={id}>
      <TextField
        id="customerID"
        label="Enter Entity"
        placeholder="..."
        value={edit}
        type="text"
        onChange={evt => setEdit(evt.target.value)}
        onBlur={async () => {
          if (edit) {
            const accounts = connection.account_mappings.map(account => {
              if (account.id === id) {
                return {...account, entity: edit.trim()};
              }
              return account;
            });
            await editConnection({...connection, account_mappings: accounts});
          } else {
            setEdit(entity);
          }
        }}
      />
      <td>{truncatedName}</td>
      <td>{acct_type}</td>
      <td>{display_number || 'N/A'}</td>
      <td>{'Active'}</td>
      <td>
        <CheckBox
          value={item.ignore}
          setValue={async value => {
            const accounts = connection.account_mappings.map(account => {
              if (account.id === id) {
                return {...account, ignore: value};
              }
              return account;
            });
            await editConnection({...connection, account_mappings: accounts});
          }}
        />
      </td>
    </tr>
  );
};
